import { IconProps } from "../../types/utils";

const Other = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9999 1.33325C7.93325 1.33325 1.33325 7.93325 1.33325 15.9999C1.33325 24.0666 7.93325 30.6666 15.9999 30.6666C24.0666 30.6666 30.6666 24.0666 30.6666 15.9999C30.6666 7.93325 24.0666 1.33325 15.9999 1.33325ZM15.9999 28.2221C9.2777 28.2221 3.7777 22.7221 3.7777 15.9999C3.7777 9.2777 9.2777 3.7777 15.9999 3.7777C22.7221 3.7777 28.2221 9.2777 28.2221 15.9999C28.2221 22.7221 22.7221 28.2221 15.9999 28.2221Z"
      fill={color || "#242424"}
    />
    <path
      d="M9.15279 13.6768C7.80834 13.6768 6.83057 14.7768 6.83057 15.999C6.83057 17.3434 7.93057 18.3212 9.15279 18.3212C10.4972 18.3212 11.475 17.2212 11.475 15.999C11.475 14.6545 10.4972 13.6768 9.15279 13.6768Z"
      fill={color || "#242424"}
    />
    <path
      d="M16.0019 13.6768C14.6575 13.6768 13.6797 14.7768 13.6797 15.999C13.6797 17.3434 14.7797 18.3212 16.0019 18.3212C17.3464 18.3212 18.3241 17.2212 18.3241 15.999C18.3241 14.6545 17.3464 13.6768 16.0019 13.6768Z"
      fill={color || "#242424"}
    />
    <path
      d="M22.8429 13.6768C21.4985 13.6768 20.5208 14.7768 20.5208 15.999C20.5208 17.3434 21.6207 18.3212 22.8429 18.3212C24.1874 18.3212 25.1651 17.2212 25.1651 15.999C25.1651 14.6545 24.0651 13.6768 22.8429 13.6768Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Other;
